<main class="login-page">

  <section class="login-showcase">

    <div class="showcase-content">

      <a
        routerLink="/"
        class="brand"
      >
        <span class="brand-icon">
          🍽️
        </span>

        <span>
          MeuCardápio
        </span>
      </a>

      <div class="showcase-text">

        <span class="showcase-badge">
          Cardápio digital completo
        </span>

        <h1>
          Seu restaurante mais moderno, organizado e conectado.
        </h1>

        <p>
          Gerencie produtos, acompanhe pedidos e receba solicitações
          diretamente pelo WhatsApp.
        </p>

      </div>

      <div class="benefits">

        <div class="benefit-item">
          <span class="benefit-icon">
            ⚡
          </span>

          <div>
            <strong>Configuração rápida</strong>

            <span>
              Crie seu cardápio em poucos minutos.
            </span>
          </div>
        </div>

        <div class="benefit-item">
          <span class="benefit-icon">
            📱
          </span>

          <div>
            <strong>Cardápio responsivo</strong>

            <span>
              Perfeito para celulares, tablets e computadores.
            </span>
          </div>
        </div>

        <div class="benefit-item">
          <span class="benefit-icon">
            💬
          </span>

          <div>
            <strong>Pedidos pelo WhatsApp</strong>

            <span>
              Seus clientes enviam o pedido diretamente para você.
            </span>
          </div>
        </div>

      </div>

    </div>

    <div class="showcase-preview">

      <div class="floating-card floating-card-orders">

        <span class="floating-icon">
          🧾
        </span>

        <div>
          <strong>Novo pedido</strong>
          <small>Pedido #1042 recebido</small>
        </div>

      </div>

      <div class="phone">

        <div class="phone-speaker"></div>

        <div class="phone-screen">

          <div class="restaurant-cover">

            <div class="restaurant-logo">
              🍕
            </div>

          </div>

          <div class="restaurant-info">

            <div>
              <h3>Pizzaria Central</h3>

              <p>
                Pizzas artesanais e massas
              </p>
            </div>

            <span class="open-badge">
              Aberto
            </span>

          </div>

          <div class="search-box">
            🔍 Buscar no cardápio
          </div>

          <div class="category-list">

            <span class="category active">
              Pizzas
            </span>

            <span class="category">
              Bebidas
            </span>

            <span class="category">
              Combos
            </span>

          </div>

          <div class="product-list">

            <article class="product-card">

              <div class="product-image">
                🍕
              </div>

              <div class="product-info">

                <strong>
                  Pizza Calabresa
                </strong>

                <span>
                  Molho, queijo, calabresa e cebola
                </span>

                <div class="product-footer">
                  <b>R$ 39,90</b>

                  <button
                    type="button"
                    tabindex="-1"
                  >
                    +
                  </button>
                </div>

              </div>

            </article>

            <article class="product-card">

              <div class="product-image">
                🍔
              </div>

              <div class="product-info">

                <strong>
                  Combo Especial
                </strong>

                <span>
                  Hambúrguer, batata e refrigerante
                </span>

                <div class="product-footer">
                  <b>R$ 32,90</b>

                  <button
                    type="button"
                    tabindex="-1"
                  >
                    +
                  </button>
                </div>

              </div>

            </article>

          </div>

        </div>

      </div>

      <div class="floating-card floating-card-sales">

        <span class="floating-icon">
          📈
        </span>

        <div>
          <strong>Vendas crescendo</strong>
          <small>Controle tudo pelo painel</small>
        </div>

      </div>

    </div>

  </section>

  <section class="login-form-section">

    <div class="mobile-brand">

      <a
        routerLink="/"
        class="brand"
      >
        <span class="brand-icon">
          🍽️
        </span>

        <span>
          MeuCardápio
        </span>
      </a>

    </div>

    <div class="login-card">

      <div class="login-header">

        <span class="login-label">
          Painel administrativo
        </span>

        <h2>
          Bem-vindo de volta
        </h2>

        <p>
          Entre com seus dados para acessar seu restaurante.
        </p>

      </div>

      <form
        class="login-form"
        (ngSubmit)="login()"
      >

        <div class="form-group">

          <label for="email">
            E-mail
          </label>

          <div class="input-wrapper">

            <span class="input-icon">
              ✉️
            </span>

            <input
              id="email"
              name="email"
              [(ngModel)]="email"
              type="email"
              placeholder="seuemail@email.com"
              autocomplete="email"
              required
              [disabled]="loading"
            >

          </div>

        </div>

        <!-- <div class="form-group">

          <div class="label-row">

            <label for="password">
              Senha
            </label>

            <a
              routerLink="/esqueci-senha"
              class="forgot-password"
            >
              Esqueci minha senha
            </a>

          </div>

          <div class="input-wrapper">

            <span class="input-icon">
              🔒
            </span>

            <input
              id="password"
              name="password"
              [(ngModel)]="password"
              type="password"
              placeholder="Digite sua senha"
              autocomplete="current-password"
              required
              [disabled]="loading"
            >

          </div>

        </div> -->

       
       
       
       <div class="form-group">

  <div class="label-row">

    <label for="password">
      Senha
    </label>

    <a
      routerLink="/esqueci-senha"
      class="forgot-password"
    >
      Esqueci minha senha
    </a>

  </div>

  <div class="input-wrapper password-wrapper">

    <span class="input-icon">
      🔒
    </span>

    <input
      id="password"
      name="password"
      [(ngModel)]="password"
      [type]="
        showPassword
          ? 'text'
          : 'password'
      "
      placeholder="Digite sua senha"
      autocomplete="current-password"
      required
      [disabled]="loading"
    >

  <button
  type="button"
  class="password-toggle"
  [disabled]="loading"
  [attr.aria-label]="
    showPassword
      ? 'Ocultar senha'
      : 'Mostrar senha'
  "
  (click)="togglePasswordVisibility()"
>

  <!-- Olho aberto -->
  <svg
    *ngIf="!showPassword"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"
    ></path>

    <circle
      cx="12"
      cy="12"
      r="3"
    ></circle>
  </svg>


  <!-- Olho fechado -->
  <svg
    *ngIf="showPassword"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      d="M3 3l18 18"
    ></path>

    <path
      d="M10.6 5.2A9.7 9.7 0 0 1 12 5c6.5 0 10 7 10 7a15.6 15.6 0 0 1-2.1 3.1"
    ></path>

    <path
      d="M6.6 6.6C3.6 8.6 2 12 2 12s3.5 7 10 7a9.8 9.8 0 0 0 5.4-1.6"
    ></path>

    <path
      d="M9.9 9.9a3 3 0 0 0 4.2 4.2"
    ></path>
  </svg>

</button>

  </div>

</div>
       
       
       
       
       
        <div
          class="error-message"
          *ngIf="error"
        >
          <span>
            ⚠️
          </span>

          <span>
            {{ error }}
          </span>
        </div>

        <button
          type="submit"
          class="login-button"
          [disabled]="loading"
        >

          <span *ngIf="!loading">
            Entrar no painel
          </span>

          <span
            class="loading-content"
            *ngIf="loading"
          >
            <span class="spinner"></span>
            Entrando...
          </span>

        </button>

      </form>

      <div class="separator">

        <span></span>

        <small>
          ainda não tem uma conta?
        </small>

        <span></span>

      </div>

      <a
        routerLink="/register"
        class="register-button"
      >
        Criar meu cardápio grátis
      </a>

      <div class="demo-access">

        <div class="demo-icon">
          💡
        </div>

        <div>
          <strong>
            Acesso de demonstração
          </strong>

          <span>
            admin&#64;cardapio.com
          </span>

          <span>
            Senha: 123456
          </span>
        </div>

      </div>

      <p class="terms">
        Ao continuar, você concorda com nossos
        <a routerLink="/termos">Termos de uso</a>
        e
        <a routerLink="/privacidade">Política de privacidade</a>.
      </p>

    </div>

  </section>

</main>